import { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../ui/table';
import { Loader2 } from 'lucide-react';
import { userService } from '../../../_services';

function SubDistributorDialog({ open, onOpenChange, distributor, isTiered }) {
  const [loading, setLoading] = useState(false);
  const [subDistData, setSubDistData] = useState([]);

  useEffect(() => {
    if (open && distributor) {
      fetchSubDistData();
    }
  }, [open, distributor, isTiered]);

  const fetchSubDistData = async () => {
    setLoading(true);
    try {
      // Parse month and year from dateMonth (format: "month,year")
      const [month, year] = distributor.dateMonth.split(',');
      
      // Get user credentials
      const Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
      const [userId, userName] = Usermeta_Data.split(':');
      
      let response;
      if (isTiered) {
        response = await userService.SecondaryCommTrackingSubDist_Tier_NonTier(
          userId,
          userName,
          month,
          year,
          distributor.distributor_UserId
        );
      } else {
        response = await userService.SecondaryCommTrackingSubDist(
          userId,
          userName,
          month,
          year,
          distributor.distributor_UserId
        );
      }
      setSubDistData(response || []);
    } catch (error) {
      console.error('Error fetching sub-distributor data:', error);
      setSubDistData([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl">
        <DialogHeader>
          <DialogTitle>
            Sub-Distributors for {distributor?.distributorName}
          </DialogTitle>
        </DialogHeader>

        {loading ? (
          <div className="flex justify-center py-8">
            <Loader2 className="h-6 w-6 animate-spin text-brand-accent" />
          </div>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Sub-Distributor Name</TableHead>
                <TableHead>Email</TableHead>
                <TableHead>Direct</TableHead>
                <TableHead>Tiered</TableHead>
                <TableHead>Override</TableHead>
                <TableHead>Secondary Override</TableHead>
                <TableHead>Total</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {subDistData.length > 0 ? (
                subDistData.map((sub, index) => (
                  <TableRow key={index}>
                    <TableCell>{sub.distributorName}</TableCell>
                    <TableCell>{sub.emailId}</TableCell>
                    <TableCell>${sub.directComm?.toFixed(2) || '0.00'}</TableCell>
                    <TableCell>${sub.tiredComm?.toFixed(2) || '0.00'}</TableCell>
                    <TableCell>${sub.subDistComm?.toFixed(2) || '0.00'}</TableCell>
                    <TableCell>${sub.parentSubDistComm?.toFixed(2) || '0.00'}</TableCell>
                    <TableCell className="font-semibold">
                      ${sub.totalCommission?.toFixed(2) || '0.00'}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={7} className="text-center text-gray-500 py-4">
                    No sub-distributors found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        )}
      </DialogContent>
    </Dialog>
  );
}

export default SubDistributorDialog;
